import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { useLocation } from "@reach/router"
import theme from "@src/styles/theme"

const BreadCrumbsWrapper = styled.div`
  display: flex;
  gap: 4px; /* Added px to the gap value */
  color: ${theme.silverShade};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.5px;
  a {
    color: ${theme.silverShade};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0.5px;
    text-decoration: none;
    text-transform: capitalize;
  }
  padding-top: 32px;
`

const LinkStyle = styled(Link)``

const BreadCrumbs = () => {
  const location = useLocation()
  const pathSegments = location.pathname.split("/").filter(Boolean)

  return (
    <BreadCrumbsWrapper>
      <LinkStyle to="/">Home</LinkStyle>
      {pathSegments.map((segment, index) => {
        const path = `/${pathSegments.slice(0, index + 1).join("/")}`
        return (
          <React.Fragment key={path}>
            <span>/</span>
            <LinkStyle to={path}>{segment.replace(/-/g, " ")}</LinkStyle>
          </React.Fragment>
        )
      })}
    </BreadCrumbsWrapper>
  )
}

export default BreadCrumbs
